import { createTheme } from '@mui/material/styles';
import {
  borderRadius,
  colorBlack,
  colorGreen,
  colorGreenLight,
  colorGrey,
  colorGreyDark,
  colorGreyLight,
  colorPeach,
  colorRed,
  fontFamily,
} from './constants';
import * as locales from '@mui/material/locale';
import { useMemo } from 'react';
import { toLocale, useLanguage } from '@/translation';

export const useTheme = () => {
  const language = useLanguage();

  const theme = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const currentLocale = (locales as any)[toLocale(language)];

    return createTheme(
      {
        typography: {
          fontFamily,
        },
        shape: {
          borderRadius: 6,
        },
        palette: {
          mode: 'dark',
          primary: {
            main: '#b9a86e',
          },
          secondary: {
            main: '#1B1B1B',
            light: '#484848',
            dark: '#121212',
          },
        },
        components: {
          MuiCard: {
            styleOverrides: {
              root: {
                backgroundColor: '#1B1B1B',
              },
            },
          },
          MuiInputLabel: {
            styleOverrides: {
              root: {
                color: 'white !important',
                WebkitTextFillColor: 'white !important',
                '&.Mui-disabled': {
                  color: 'white !important',
                  WebkitTextFillColor: 'white !important',
                },
              },
            },
          },
          MuiOutlinedInput: {
            styleOverrides: {
              input: {
                color: 'white !important',
                WebkitTextFillColor: 'white !important',
                '&.Mui-disabled': {
                  color: 'white !important',
                  WebkitTextFillColor: 'white !important',
                },
              },
            },
          },
          MuiFormControlLabel: {
            styleOverrides: {
              root: {
                color: 'white !important',
                WebkitTextFillColor: 'white !important',
                '&.Mui-disabled': {
                  color: 'white !important',
                  WebkitTextFillColor: 'white !important',
                },
              },
            },
          },
        },

        // common: {
        //   black: colorBlack,
        // },
        // grey: {
        //   '100': colorGreyLight,
        //   '500': colorGrey,
        //   '700': colorGreyDark,
        // },

        // typography: {
        //   fontFamily: 'Spline Sans',},
      },
      currentLocale,
    );
  }, [language]);

  return theme;
};
